import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EncryptionProvider } from '../../providers/encryption/encryption';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { TransactionAlertProvider } from '../../providers/transaction-alert/transaction-alert';
import { LoadingProvider } from '../../providers/loading/loading';

/**
 * Generated class for the ChangePinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-change-pin',
  templateUrl: 'change-pin.html',
})
export class ChangePinPage {

  changePin:FormGroup;
  submitAttempt = false;
  passValidation = false;
  confirm_pin = '';
  new_pin = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, private encrypt :EncryptionProvider, private request : RequestServiceProvider, private alert: TransactionAlertProvider,private loading :LoadingProvider) {

    this.changePin = this.formBuilder.group({
      old_pin: ['',Validators.compose([Validators.minLength(4),Validators.maxLength(4), Validators.required])],
      new_pin:['',Validators.compose([Validators.minLength(4),Validators.maxLength(4), Validators.required])],
      confirm_pin:['',Validators.compose([Validators.minLength(4),Validators.maxLength(4), Validators.required])]  
  });

  }

  checkFocus(event){
    this.passValidation = false;
  }

  submit(){
    this.submitAttempt = true;
   
    if(this.changePin.valid){
      if(this.changePin.value.new_pin != this.changePin.value.confirm_pin){
        this.passValidation = true;
      }
      if(this.changePin.valid && !this.passValidation){

        this.loading.presentLoading('processing...')

        const oldPin = this.encrypt.makeEncryption(this.changePin.value.old_pin, window.localStorage.getItem('session'));

        const newPin = this.encrypt.makeEncryption(this.changePin.value.new_pin, window.localStorage.getItem('session'));

        this.request.postChangePin(oldPin, newPin).subscribe(
              data => {
                this.loading.loader.dismiss().catch(()=>{})
                if(data.json().code === "0000"){
                  this.alert.presentSuccessForChangePassword(data.json().desc);
                }else{
                  this.alert.presentNormalErrorAlert(data.json().desc)
                }
              },
              error => {
                this.loading.loader.dismiss().catch(()=>{})
                this.alert.presentNormalErrorAlert(error.json().message);
                if(error.json().code == 403){
                  this.request.logout();
                }
              }
        )
      
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChangePinPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-pin/change-pin.ts